import * as T from 'prop-types';
import { Route } from 'react-router-dom';

import { AuthProvider } from '../contexts/auth';

const PrivateRoute = ({ children, ...rest }) => {
  return (
    <Route {...rest}>
      <AuthProvider>{children}</AuthProvider>
    </Route>
  );
};

PrivateRoute.propTypes = {
  children: T.node.isRequired,
};

export default PrivateRoute;
